import { FC } from "react";
import { Container } from "../Container";
import Image from "next/image";
import styles from "./ThankYou.module.scss";
import { useTranslation } from "next-i18next";
import Button from "../Button";
import Text from "../Text";
import classNames from "classnames";
import { useRouter } from "next/router";

interface ThankYouProps {
  title?: string;
  description?: string;
  onBack?: () => void;
}

const ThankYou: FC<ThankYouProps> = ({ title, description, onBack }) => {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <div className={styles.container}>
      <Container className="w-full">
        <div className="w-full px-6 py-5">
          <Image
            src="/svgs/logo.svg"
            alt="CX Genie logo"
            width={124}
            height={32}
          />
        </div>
      </Container>
      <div
        className={classNames(
          styles.message_container,
          "flex flex-col items-center justify-center flex-1"
        )}
      >
        {!!title && (
          <h1
            className={styles.title}
            dangerouslySetInnerHTML={{
              __html: t(title),
            }}
          />
        )}
        {!!description && (
          <Text className="mt-5 !text-center" type="body-1">
            {t(description)}
          </Text>
        )}
        <Button
          className="mt-8"
          size="large"
          onClick={() => {
            if (onBack) {
              onBack();
            } else {
              router.replace("/");
            }
          }}
        >
          {t("back_to_homepage")}
        </Button>
      </div>
    </div>
  );
};

export default ThankYou;
